/**
 * @fileoverview LOCI · CLT (Charlotte) city-specific color tokens.
 *
 * Values are generated from `apps/web/design-system/tokens/tokens.css` (WEB-999) — edit the
 * `--clt-*` / `--bg-sunken` tokens there and run `pnpm --filter web tokens:generate`.
 *
 * The CLT colorway pairs Skyline Blue (the teal/blue glass of Charlotte's
 * uptown towers at dusk) with Ember (a warm sunset contrast). City tokens
 * are theme-invariant and do not flip with `data-theme`.
 *
 * @since WEB-47 (M1.3); promoted to per-page dominant CTA palette in WEB-332
 *   (DS v1.1.0). Mirrors `brandColors.city.clt` in
 *   `packages/ui/src/theme/design-tokens.ts` — drift between the two is
 *   guarded by the tokens-pipeline tests.
 */
import * as generated from '../theme/generated/tokens.generated';
export const cltAccentTokens = generated.cltAccentTokens;
/** Light-theme accent-as-text foregrounds (darkened for AA on light grounds). */
export const cltAccentForegroundTokensLight = generated.cltAccentForegroundTokensLight;
/** Dark-theme accent-as-text foregrounds (original accents already clear AA). */
export const cltAccentForegroundTokensDark = generated.cltAccentForegroundTokensDark;
export const sunkenBackgroundTokens = generated.sunkenBackgroundTokens;
